// extracted by mini-css-extract-plugin
module.exports =  {"buttonWrapper":"CustomerFeedbackButton-CustomerFeedbackButton-buttonWrapper-dd6df6cb","button":"CustomerFeedbackButton-CustomerFeedbackButton-button-c14b4845"};